//
//
//
//
//
//

import CallLogView from './components/callLog-view';

export default {
    name: 'callLogDetail',
    components: { CallLogView },
    data() {
        return {
            id: 0
        };
    },
    created() {
        this.id = parseInt(this.$route.params.callLogId) || 0;
    }
};
